import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import proposalService from '../services/proposalService';
import { companyService } from '../services/companyService';
import { imagesAPI } from '../services/imageService';
import './Dashboard.css';

const Dashboard = () => {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [showProposalForm, setShowProposalForm] = useState(false);
  const [editingProposal, setEditingProposal] = useState(null);
  const [partners, setPartners] = useState([]);

  // Récupérer l'utilisateur
  const getCurrentUser = () => {
    try {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      console.error('Erreur récupération user:', err);
      return null;
    }
  };




  const currentUser = getCurrentUser();
  const currentPartner = currentUser ? {
    _id: currentUser.companyId,
    name: currentUser.companyName
  } : null;



  // Vérifier si l'utilisateur est un partenaire
  const supadmin = currentUser?.supadmin === true;

  // Catégories pour les propositions
  const CATEGORIES = [
    { id: 'financial', name: 'Support financier', icon: '💰' },
    { id: 'family', name: 'Famille & éducation', icon: '👨‍👩‍👧‍👦' },
    { id: 'shopping', name: 'Achats courants', icon: '🛍️' },
    { id: 'leisure', name: 'Voyages & loisirs', icon: '🌴' },
    { id: 'health', name: 'Santé', icon: '🏥' },
    { id: 'food', name: 'Restauration', icon: '🍽️' },
    { id: 'religious', name: 'Vie spirituelle', icon: '🕋' },
    { id: 'wellness', name: 'Sport & bien-être', icon: '🧘' },
    { id: 'training', name: 'Formation pro', icon: '💼' },
    { id: 'culture', name: 'Culture', icon: '🎭' }
  ];

  // Types d'offres
  const OFFER_TYPES = [
    { id:'discount',     name:'Réduction',     icon:'🏷️', color:'#667eea' },
  { id:'voucher',      name:'Bon / Coupon',  icon:'🧾', color:'#feca57' },
  { id:'cash_support', name:'Prise en charge',icon:'🏛️', color:'#00b894' },
  { id:'credit',       name:'Crédit / Paiement', icon:'💳', color:'#54a0ff' },
  { id:'gift',         name:'Cadeau',        icon:'🎁', color:'#ff9ff3' },
  { id:'access',       name:'Accès VIP',     icon:'🔑', color:'#5f27cd' },
  { id:'event',        name:'Événement',     icon:'🎟️', color:'#48dbfb' },
  { id:'logistics',    name:'Livraison / Promo', icon:'🚚', color:'#96ceb4' },
  ];


  // Dans Dashboard.js, remplacez le state newProposal par :
const [newProposal, setNewProposal] = useState({
  title: '',
  description: '',
  category: 'shopping',
  type: 'discount',
  discount: '',
  conditions: [''],
  usageInstructions: [''],
  partnerId: currentPartner?._id || '', // Garde l'entreprise actuelle par défaut
  partnerName: currentPartner?.name || ''
});

  // Charger les propositions du partenaire
  const fetchProposals = async () => {
    if (!supadmin) return;
    
    try {
      setLoading(true);
      setError('');
      
      const data = await proposalService.getPartnerProposals({
        status: selectedStatus !== 'all' ? selectedStatus : null
      });
      
      
      // FILTRER pour garder seulement les 3 statuts voulus
      const filteredProposals = (data || []).filter(proposal => 
        ['pending', 'accepted', 'rejected' , 'active', 'inactive'].includes(proposal.status)
      );
      
      setProposals(filteredProposals|| []);

      
    } catch (err) {
      const errorMessage = err.message || 'Erreur lors du chargement des propositions';
      setError(errorMessage);
      setProposals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (supadmin) {
      fetchProposals();
    }
  }, [selectedStatus, supadmin]);




// Nouvelle fonction pour charger les entreprises partenaires
// Remplacez VOTRE fonction fetchPartners par celle-ci :
const fetchPartners = async () => {
  try {
    console.log('Chargement des partenaires...');
    const response = await companyService.getCompanies();
    console.log('Réponse de getCompanies:', response);
    
    // Vérifiez le format de la réponse
    if (response && Array.isArray(response)) {
      // Si la réponse est déjà un tableau
      setPartners(response);
    } else if (response && response.data && Array.isArray(response.data)) {
      // Si la réponse a une propriété "data"
      setPartners(response.data);
    } else if (response && Array.isArray(response.companies)) {
      // Si la réponse a une propriété "companies"
      setPartners(response.companies);
    } else {
      console.warn('Format de réponse non supporté:', response);
      setPartners([]); // Définit un tableau vide par défaut
    }
    
    console.log('Partenaires chargés:', partners);
  } catch (err) {
    console.error('Erreur chargement partenaires:', err);
    setPartners([]); // Définit un tableau vide en cas d'erreur
  }
};

// Appelez cette fonction dans useEffect
useEffect(() => {
  if (supadmin) {
    fetchProposals();
    fetchPartners(); // Ajoutez cet appel
  }
}, [selectedStatus, supadmin]);





  // Soumettre une nouvelle proposition
  const handleSubmitProposal = async (e) => {
    e.preventDefault();
    if (!supadmin) return;
    
    try {
      setError('');
      
      // Le partenaire propose pour SON entreprise
      const proposalData = {
        ...newProposal,
      };
      
      await proposalService.submitProposal(proposalData);
      
      setNewProposal({
        title: '',
        description: '',
        category: 'shopping',
        type: 'discount',
        discount: '',
        conditions: [''],
        usageInstructions: ['']
      });
      
      setShowProposalForm(false);
      await fetchProposals();
      
      alert('✅ Votre proposition a été envoyée !');
    } catch (err) {
      setError(err.message || 'Erreur lors de l\'envoi de la proposition');
    }
  };

  // Modifier une proposition
  const handleUpdateProposal = async (e) => {
    e.preventDefault();
    if (!supadmin) return;
    
    try {
      setError('');
      await proposalService.updateProposal(editingProposal._id, editingProposal);
      
      setEditingProposal(null);
      await fetchProposals();
      
      alert('✅ Proposition modifiée !');
    } catch (err) {
      setError(err.message || 'Erreur lors de la modification');
    }
  };

  // Supprimer une proposition
  const handleDeleteProposal = async (proposalId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cette proposition ?')) {
      return;
    }

    try {
      setError('');
      await proposalService.deleteProposal(proposalId);
      await fetchProposals();
      alert('✅ Proposition supprimée !');
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression');
    }
  };
  // Ajoute cette fonction avec tes autres fonctions (après handleDeleteProposal)

// 🔥 AJOUT: Fonction pour ajouter une image à une proposition existante
  // 🔥 CORRECTION: Fonction pour ajouter une image à une proposition existante
const handleAddImage = async (proposalId) => {
  try {
    // Trouve la proposition actuelle pour avoir TOUTES les données
    const currentProposal = proposals.find(p => p._id === proposalId);
    if (!currentProposal) {
      alert('Proposition non trouvée');
      return;
    }

    // Créer un input file caché
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (file) {
        try {
            const maxSize =  1024 * 1024; // 1MB en bytes
            if (file.size > maxSize) {
              alert('❌ Fichier trop volumineux. Maximum 1Mo autorisé.');
              return; // Arrête l'exécution si fichier trop gros
            }
              // Upload de l'image
          const uploadResult = await imagesAPI.uploadImage(file, proposalId);
          
          if (uploadResult.success) {
            // 🔥 CORRECTION: Envoie l'objet COMPLET comme dans handleUpdateProposal
            const updatedProposal = {
              ...currentProposal, // Toutes les données existantes
              imageUrl: uploadResult.url // Ajoute/modifie l'URL de l'image
            };
            
            // 🔥 Même appel que handleUpdateProposal
            await proposalService.updateProposal(proposalId, updatedProposal);
            await fetchProposals();
            alert('✅ Photo ajoutée avec succès !');
          }
        } catch (error) {
          console.error('Erreur ajout photo:', error);
          alert('❌ Erreur lors de l\'ajout de la photo: ' + error.message);
        }
      }
    };
    
    input.click();
  } catch (error) {
    console.error('Erreur sélection image:', error);
    alert('Erreur lors de la sélection de l\'image');
  }
};

  // Obtenir le statut avec style
  const getStatusInfo = (status) => {
    const statusConfig = {
      pending: { label: 'En attente', color: '#FF9800', icon: '⏳' },
      accepted: { label: 'Acceptée', color: '#20C997', icon: '✅' },
      active: { label: 'Active', color: '#4CAF50', icon: '🟢' },
      inactive: { label: 'Inactive', color: '#6c757d', icon: '🔴' },
      rejected: { label: 'Refusée', color: '#FF6B6B', icon: '❌' }
    };
    return statusConfig[status] || statusConfig.pending;
  };

  // Si l'utilisateur n'est pas partenaire
  if (!supadmin) {
    return (
      <div className="dashboard">
        <div className="page-header">
          <div className="page-title">
            <h1>Accès Partenaire</h1>
            <p>Cette section est réservée aux partenaires</p>
          </div>
        </div>
        <Card className="empty-state">
          <div className="empty-icon">🔒</div>
          <h3 className="empty-title">Accès non autorisé</h3>
          <p className="empty-text">Vous devez être un partenaire pour accéder à cette section</p>
        </Card>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="dashboard">
        <div className="page-header">
          <div className="page-title">
            <h1>Mes Propositions d'Offres</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement de vos propositions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      {/* En-tête */}
      <div className="page-header">
        <div className="page-title">
          <h1>Mes Propositions d'Offres</h1>
          <p>Proposez nous de nouvelles offres</p>
        </div>
        
        <div className="header-actions">
          <div className="filters">
            <select 
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="filter-select"
            >
              <option value="all">📋 Tous les statuts</option>
              <option value="pending">⏳ En attente</option>
              <option value="accepted">✅ Acceptées</option>
              <option value="rejected">❌ Refusées</option>
              <option value="active">🟢 Actives</option>
              <option value="inactive">🔴 Inactives</option>
            </select>

            <Button 
              variant="primary" 
              onClick={() => setShowProposalForm(true)}
            > 💡 Nouvelle proposition
            </Button>
          </div>
        </div>
      </div>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card">
          <div className="error-message">
            <span>❌</span>
            <div className="error-content">
              <strong>Erreur</strong>
              <p>{error}</p>
            </div>
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Grille des propositions */}
      <div className="proposals-grid">
        {proposals.map(proposal => {
          const statusInfo = getStatusInfo(proposal.status);
          const categoryInfo = CATEGORIES.find(c => c.id === proposal.category) || CATEGORIES[0];
          const typeInfo = OFFER_TYPES.find(t => t.id === proposal.type) || OFFER_TYPES[0];
          
          return (
            // Dans la partie "Grille des propositions", remplace le contenu de la carte par ceci :

<Card key={proposal._id} className="proposal-card">
  {/* 🔥 AJOUT: Afficher l'image si elle existe */}
  {proposal.imageUrl && (
    <div className="proposal-image">
      <img src={proposal.imageUrl} alt={proposal.title} />
    </div>
  )}
  
  {/* En-tête avec statut */}
  <div className="proposal-header">
    <div className="proposal-category">
      <span className="category-icon">{categoryInfo.icon}</span>
      <span className="category-name">{categoryInfo.name}</span>
    </div>
    <span className={`status-badge ${proposal.status}`}>
      {statusInfo.icon} {statusInfo.label}
    </span>
  </div>

  {/* Titre et description */}
  <h3 className="proposal-title">{proposal.title}</h3>
  <p className="proposal-description">{proposal.description}</p>

  {/* 🔥 AJOUT: Informations supplémentaires du partenaire */}
  <div className="proposal-partner-info">
    <div className="partner-detail">
      <strong>Partenaire:</strong> {proposal.partnerName}
    </div>
    {proposal.partnerId && (
      <div className="partner-detail">
        <strong>ID Partenaire:</strong> <code>{proposal.partnerId}</code>
      </div>
    )}
  </div>

  {/* Conditions d'utilisation */}
  {proposal.conditions && proposal.conditions.length > 0 && proposal.conditions[0] !== '' && (
    <div className="proposal-conditions">
      <strong>Conditions :</strong>
      <ul>
        {proposal.conditions.map((condition, index) => (
          condition && <li key={index}>{condition}</li>
        ))}
      </ul>
    </div>
  )}

  {/* Instructions d'utilisation */}
  {proposal.usageInstructions && proposal.usageInstructions.length > 0 && proposal.usageInstructions[0] !== '' && (
    <div className="proposal-instructions">
      <strong>Instructions :</strong>
      <ul>
        {proposal.usageInstructions.map((instruction, index) => (
          instruction && <li key={index}>{instruction}</li>
        ))}
      </ul>
    </div>
  )}

  {/* Détails */}
  <div className="proposal-details">
    <div className="detail-row">
      <span className="detail-label">Type:</span>
      <span className="detail-value">
        {typeInfo.icon} {typeInfo.name}
      </span>
    </div>
    
    {/* 🔥 AJOUT: Catégorie */}
    <div className="detail-row">
      <span className="detail-label">Catégorie:</span>
      <span className="detail-value">{categoryInfo.name}</span>
    </div>
    
    <div className="detail-row">
      <span className="detail-label">Avantage:</span>
      <span className="detail-value">{proposal.discount || 'Non spécifié'}</span>
    </div>
    
    {/* 🔥 AJOUT: Intéressements entreprises */}
    {proposal.totalInterestedCompanies !== undefined && (
      <div className="detail-row">
        <span className="detail-label">Entreprises intéressées:</span>
        <span className="detail-value">{proposal.totalInterestedCompanies}</span>
      </div>
    )}
    
    {/* 🔥 AJOUT: ID de la proposition */}
    <div className="detail-row">
      <span className="detail-label">ID:</span>
      <span className="detail-value">
        <code className="proposal-id">{proposal._id}</code>
      </span>
    </div>
    
    <div className="detail-row">
      <span className="detail-label">Soumis le:</span>
      <span className="detail-value">
        {new Date(proposal.createdAt).toLocaleDateString('fr-FR')}
      </span>
    </div>
    
    {/* 🔥 AJOUT: Mis à jour le */}
    {proposal.updatedAt && (
      <div className="detail-row">
        <span className="detail-label">Mis à jour le:</span>
        <span className="detail-value">
          {new Date(proposal.updatedAt).toLocaleDateString('fr-FR')}
        </span>
      </div>
    )}
    
    {/* 🔥 AJOUT: Créé par */}
    {proposal.createdBy && (
      <div className="detail-row">
        <span className="detail-label">Créé par:</span>
        <span className="detail-value">
          <code>{proposal.createdBy}</code>
        </span>
      </div>
    )}
  </div>

  {/* Actions */}
  <div className="proposal-actions">
    {proposal.status && (
      <div className="action-buttons">
        <Button 
          variant="secondary" 
          size="sm"
          onClick={() => setEditingProposal(proposal)}
        >
          ✏️ Modifier
        </Button>

        {/* 🔥 AJOUT: Bouton pour ajouter une image */}
        <Button 
          variant="primary" 
          size="sm"
          onClick={() => handleAddImage(proposal._id)}
        >
          {proposal.imageUrl ? '✏️ Changer photo' : '➕ Ajouter photo'}
        </Button>

        <Button 
          variant="danger" 
          size="sm"
          onClick={() => handleDeleteProposal(proposal._id)}
        >
          🗑️ Supprimer
        </Button>
      </div>
    )}
    
    {/* 🔥 AJOUT: Feedback étendu */}
    {proposal.feedback && (
      <div className="proposal-feedback">
        <strong>📝 Retour de l'équipe:</strong> 
        <p>{proposal.feedback}</p>
      </div>
    )}
  </div>
</Card>
          );
        })}
      </div>

      {/* État vide */}
      {proposals.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">💡</div>
          <h3 className="empty-title">Aucune proposition</h3>
          <p className="empty-text">
            {selectedStatus === 'all' 
              ? "Commencez par proposer votre première offre"
              : "Aucune proposition avec ce statut"
            }
          </p>
          <Button 
            variant="primary"
            onClick={() => setShowProposalForm(true)}
          >
            💡 Faire une proposition
          </Button>
        </Card>
      )}

      {/* Modal nouvelle proposition */}
      {showProposalForm && (
        <div className="modal-overlay">
          <Card className="modal" padding="xl">
            <div className="modal-header">
              <h2>💡 Nouvelle Proposition</h2>
              <button onClick={() => setShowProposalForm(false)}>✕</button>
            </div>
            
            <form onSubmit={handleSubmitProposal} className="proposal-form">
              <div className="form-group">
                <label>Titre de l'offre *</label>
                <input
                  type="text"
                  value={newProposal.title}
                  onChange={(e) => setNewProposal({...newProposal, title: e.target.value})}
                  required
                  placeholder="Donnez un titre court et percutant à votre offre..."
                />
              </div>

              <div className="form-group">
                <label>Description *</label>
                <textarea
                  value={newProposal.description}
                  onChange={(e) => setNewProposal({...newProposal, description: e.target.value})}
                  required
                  placeholder="Décrivez l'offre en détail..."
                  rows="3"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Catégorie *</label>
                  <select
                    value={newProposal.category}
                    onChange={(e) => setNewProposal({...newProposal, category: e.target.value})}
                    required
                  >
                    {CATEGORIES.map(cat => (
                      <option key={cat.id} value={cat.id}>
                        {cat.icon} {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Type d'offre *</label>
                  <select
                    value={newProposal.type}
                    onChange={(e) => setNewProposal({...newProposal, type: e.target.value})}
                    required
                  >
                    {OFFER_TYPES.map(type => (
                      <option key={type.id} value={type.id}>
                        {type.icon} {type.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Avantage proposé *</label>
                <input
                  type="text"
                  value={newProposal.discount}
                  onChange={(e) => setNewProposal({...newProposal, discount: e.target.value})}
                  required
                  placeholder="Ex: 25% de réduction, Cadeau offert, Bon d'achat..."
                />
              </div>

              <div className="form-group">
                <label>Conditions d'utilisation</label>
                <textarea
                  value={newProposal.conditions.join('\n')}
                  onChange={(e) => setNewProposal({
                    ...newProposal, 
                    conditions: e.target.value.split('\n') // ENLÈVE LE .filter() ICI
                  })}

                  
                  placeholder="Entrez chaque condition sur une nouvelle ligne&#10;Ex: Valable du dimenche au jeudi&#10;Ex: Sur présentation de la carte d'identité"
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Instructions d'utilisation</label>
                <textarea
                  value={newProposal.usageInstructions.join('\n')}
                  onChange={(e) => setNewProposal({
                    ...newProposal, 
                    usageInstructions: e.target.value.split('\n') // ENLÈVE LE .filter() ICI
                  })}
                  placeholder="Entrez chaque instruction sur une nouvelle ligne&#10;Ex: Présenter le coupon à la caisse&#10;Ex: Réserver 48h à l'avance"
                  rows="3"
                />
              </div>



              {/* Dans le formulaire de création, après les instructions d'utilisation */}
<div className="form-group">
  <label>Assigner à une entreprise partenaire</label>
  <select
    value={newProposal.partnerId}
    onChange={(e) => {
      const selectedPartner = partners.find(p => p._id === e.target.value);
      setNewProposal({
        ...newProposal,
        partnerId: e.target.value,
        partnerName: selectedPartner ? selectedPartner.name : ''
      });
    }}
  >
    {/* Option par défaut : son entreprise */}
    <option value={currentPartner?._id || ''}>
      {currentPartner?.name || 'Mon entreprise'}
    </option>
    
    {/* Autres entreprises partenaires */}
    {partners
      .filter(partner => partner._id !== currentPartner?._id)
      .map(partner => (
        <option key={partner._id} value={partner._id}>
          📋 {partner.name} (ID: {partner._id.substring(0, 8)}...)
        </option>
      ))
    }
  </select>
  <p className="form-help">
    Par défaut: votre entreprise. Sélectionnez une autre entreprise partenaire si nécessaire.
  </p>
</div>

              <div className="form-actions">
                <Button type="button" variant="secondary" onClick={() => setShowProposalForm(false)}>
                  Annuler
                </Button>
                <Button type="submit" variant="primary">
                  💡 Soumettre la proposition
                </Button>
              </div>
            </form>
          </Card>
        </div>
      )}

      {/* Modal modification proposition */}
{editingProposal && (
  <div className="modal-overlay">
    <Card className="modal" padding="xl">
      <div className="modal-header">
        <h2>✏️ Modifier la Proposition</h2>
        <button onClick={() => setEditingProposal(null)}>✕</button>
      </div>
      
      <form onSubmit={handleUpdateProposal} className="proposal-form">
        <div className="form-group">
          <label>Titre de l'offre *</label>
          <input
            type="text"
            value={editingProposal.title}
            onChange={(e) => setEditingProposal({...editingProposal, title: e.target.value})}
            required
          />
        </div>

        <div className="form-group">
          <label>Description *</label>
          <textarea
            value={editingProposal.description}
            onChange={(e) => setEditingProposal({...editingProposal, description: e.target.value})}
            required
            rows="3"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Catégorie *</label>
            <select
              value={editingProposal.category}
              onChange={(e) => setEditingProposal({...editingProposal, category: e.target.value})}
              required
            >
              {CATEGORIES.map(cat => (
                <option key={cat.id} value={cat.id}>
                  {cat.icon} {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Type d'offre *</label>
            <select
              value={editingProposal.type}
              onChange={(e) => setEditingProposal({...editingProposal, type: e.target.value})}
              required
            >
              {OFFER_TYPES.map(type => (
                <option key={type.id} value={type.id}>
                  {type.icon} {type.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* 🔥 AJOUT: Statut modifiable */}
        <div className="form-group">
          <label>Statut</label>
          <select
            value={editingProposal.status}
            onChange={(e) => setEditingProposal({...editingProposal, status: e.target.value})}
          >
            <option value="pending">⏳ En attente</option>
            <option value="accepted">✅ Acceptée</option>
            <option value="active">🟢 Active</option>
            <option value="inactive">🔴 Inactive</option>
            <option value="rejected">❌ Refusée</option>
          </select>
        </div>

        <div className="form-group">
          <label>Avantage proposé *</label>
          <input
            type="text"
            value={editingProposal.discount || ''}
            onChange={(e) => setEditingProposal({...editingProposal, discount: e.target.value})}
            required
          />
        </div>

{/* APRÈS : sélecteur d'entreprise */}
<div className="form-group">
  <label>Assigner à une entreprise partenaire</label>
  <select
    value={editingProposal.partnerId || ''}
    onChange={(e) => {
      const selectedPartner = partners.find(p => p._id === e.target.value);
      setEditingProposal({
        ...editingProposal,
        partnerId: e.target.value,
        partnerName: selectedPartner ? selectedPartner.name : ''
      });
    }}
  >
    {/* Option par défaut : entreprise actuelle de la proposition */}
    <option value={editingProposal.partnerId || ''}>
      {editingProposal.partnerName || 'Sélectionner une entreprise'}
    </option>
    
    {/* Toutes les entreprises partenaires */}
    {partners
      .filter(partner => partner._id !== editingProposal.partnerId)
      .map(partner => (
        <option key={partner._id} value={partner._id}>
          📋 {partner.name} (ID: {partner._id?.substring(0, 8)}...)
        </option>
      ))
    }
  </select>
  <p className="form-help">
    Changer l'entreprise propriétaire de cette proposition
  </p>
</div>

        <div className="form-group">
          <label>Conditions d'utilisation</label>
          <textarea
            value={editingProposal.conditions?.join('\n') }
            onChange={(e) => setEditingProposal({
              ...editingProposal, 
              conditions: e.target.value.split('\n')
            })}
            placeholder="Entrez chaque condition sur une nouvelle ligne"
            rows="3"
          />
        </div>

        <div className="form-group">
          <label>Instructions d'utilisation</label>
          <textarea
            value={editingProposal.usageInstructions?.join('\n') }
            onChange={(e) => setEditingProposal({
              ...editingProposal, 
              usageInstructions: e.target.value.split('\n')
            })}
            placeholder="Entrez chaque instruction sur une nouvelle ligne"
            rows="3"
          />
        </div>


        <div className="form-group">
          <label>Créé par (User ID)</label>
          <input
            type="text"
            value={editingProposal.createdBy || ''}
            onChange={(e) => setEditingProposal({...editingProposal, createdBy: e.target.value})}
            placeholder="ID utilisateur"
          />
        </div>

        <div className="form-group">
          <label>Entreprises intéressées (JSON)</label>
          <textarea
            value={JSON.stringify(editingProposal.interestedCompanies || [], null, 2)}
            onChange={(e) => {
              try {
                const parsed = JSON.parse(e.target.value);
                setEditingProposal({...editingProposal, interestedCompanies: parsed});
              } catch (err) {
                // Garde la valeur en texte si JSON invalide
              }
            }}
            rows="5"
            placeholder="Format JSON des entreprises intéressées"
          />
         <p className="form-help">
          Format: [{'{'}"companyId": "...", "companyName": "...", "status": "interested"{'}'}]
        </p>
        
        </div>

<div className="form-group">
  <label>Date de création</label>
  <input
    type="datetime-local"
    value={editingProposal.createdAt ? 
      new Date(editingProposal.createdAt).toISOString().slice(0, 16) : ''}
    onChange={(e) => {
      // 🔥 PROTECTION : Vérifier si la date est valide avant conversion
      if (e.target.value) {
        try {
          const date = new Date(e.target.value);
          if (!isNaN(date.getTime())) {
            setEditingProposal({
              ...editingProposal, 
              createdAt: date.toISOString()
            });
          }
        } catch (err) {
          // Si erreur, garder l'ancienne valeur
          console.warn('Date invalide:', e.target.value);
        }
      } else {
        // Si champ vide, mettre undefined
        setEditingProposal({
          ...editingProposal, 
          createdAt: undefined
        });
      }
    }}
  />
</div>


<div className="form-group">
  <label>Date de modification</label>
  <input
    type="datetime-local"
    value={editingProposal.updatedAt ? 
      new Date(editingProposal.updatedAt).toISOString().slice(0, 16) : ''}
    onChange={(e) => {
      // 🔥 PROTECTION : Vérifier si la date est valide avant conversion
      if (e.target.value) {
        try {
          const date = new Date(e.target.value);
          if (!isNaN(date.getTime())) {
            setEditingProposal({
              ...editingProposal, 
              updatedAt: date.toISOString()
            });
          }
        } catch (err) {
          // Si erreur, garder l'ancienne valeur
          console.warn('Date invalide:', e.target.value);
        }
      } else {
        // Si champ vide, mettre undefined
        setEditingProposal({
          ...editingProposal, 
          updatedAt: undefined
        });
      }
    }}
  />
</div>


        {/* 🔥 AJOUT: Entreprises intéressées */}
        <div className="form-group">
          <label>Nombre d'entreprises intéressées</label>
          <input
            type="number"
            min="0"
            value={editingProposal.totalInterestedCompanies || 0}
            onChange={(e) => setEditingProposal({
              ...editingProposal, 
              totalInterestedCompanies: parseInt(e.target.value) || 0
            })}
          />
        </div>

        {/* 🔥 AJOUT: Champ pour l'URL de l'image */}
        <div className="form-group">
          <label>URL de l'image</label>
          <input
            type="text"
            value={editingProposal.imageUrl || ''}
            onChange={(e) => setEditingProposal({...editingProposal, imageUrl: e.target.value})}
            placeholder="https://exemple.com/image.jpg"
          />
          {editingProposal.imageUrl && (
            <div style={{marginTop: '10px'}}>
              <img 
                src={editingProposal.imageUrl} 
                alt="Aperçu" 
                style={{maxWidth: '100px', maxHeight: '100px', borderRadius: '4px'}}
              />
            </div>
          )}
        </div>

        <div className="form-actions">
          <Button type="button" variant="secondary" onClick={() => setEditingProposal(null)}>
            Annuler
          </Button>
          <Button type="submit" variant="primary">
            💾 Enregistrer
          </Button>
        </div>
      </form>
    </Card>
  </div>
)}
    </div>
  );
};

export default Dashboard;